module.exports = __webpack_public_path__ + "media/packs/images/rapid-test-568298362bbfa05d02251093957badd1.png";